 import React, { Component } from "react";
 import { Line } from "react-chartjs-2";
 import firebase from '../store/firebase'

class MEVPriceGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        labels: [], // Time values for the X-axis
        datasets: [
          {
            label: "MEV Price (USD)",
            data: [], // Price values for the Y-axis
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            fill: true,
          },
        ],
      },
      isLoading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const snapshot = await firebase.database.ref("MEV").get();
      const data = snapshot.val();

      if (data) {
        // Convert Firebase object to an array and sort by time
        const sortedData = Object.values(data).sort(
          (a, b) => new Date(a.time) - new Date(b.time)
        );

        // Extract date-time and price
        const dateTimes = sortedData.map((entry) =>
          new Date(entry.time).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
        );
        const prices = sortedData.map((entry) => parseFloat(entry.price));

        this.setState({
          data: {
            ...this.state.data,
            labels: dateTimes,
            datasets: [
              {
                ...this.state.data.datasets[0],
                data: prices,
              },
            ],
          },
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({ error: error.message, isLoading: false });
    }
  };

  render() {
    const { data, isLoading, error } = this.state;

    if (isLoading) {
      return <p>Loading graph data...</p>;
    }

    if (error) {
      return <p>Error loading data: {error}</p>;
    }

    return (
      <div>
        <h2>MEV Price Over Time</h2>
        <Line
          data={data}
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: "top",
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: "Date & Time",
                },
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 10, // Adjust for clarity on large datasets
                },
              },
              y: {
                title: {
                  display: true,
                  text: "Price (USD)",
                },
              },
            },
          }}
        />
      </div>
    );
  }
}

export default MEVPriceGraph;

////////////////////////////////////////////////////////
// import React, { Component } from "react";
// import { Line } from "react-chartjs-2";
// import firebase from '../store/firebase'

// class MEVPriceGraph extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: {
//         labels: [], // Time values for the X-axis
//         datasets: [
//           {
//             label: "MEV Price (USD)",
//             data: [], // Price values for the Y-axis
//             borderColor: "rgba(75, 192, 192, 1)",
//             backgroundColor: "rgba(75, 192, 192, 0.2)",
//             fill: true,
//           },
//         ],
//       },
//       isLoading: true,
//       error: null,
//     };
//   }

//   componentDidMount() {
//     this.fetchData();
//   }

//   fetchData = async () => {
//     try {
//       const snapshot = await firebase.database.ref("MEV").get();
//       const data = snapshot.val();

//       if (data) {
//         // Convert Firebase object to an array and sort by time
//         const sortedData = Object.values(data).sort(
//           (a, b) => new Date(a.time) - new Date(b.time)
//         );

//         // Extract time and price
//         const times = sortedData.map((entry) =>
//           new Date(entry.time).toLocaleTimeString("en-US", {
//             hour: "2-digit",
//             minute: "2-digit",
//             second: "2-digit",
//           })
//         );
//         const prices = sortedData.map((entry) => parseFloat(entry.price));

//         this.setState({
//           data: {
//             ...this.state.data,
//             labels: times,
//             datasets: [
//               {
//                 ...this.state.data.datasets[0],
//                 data: prices,
//               },
//             ],
//           },
//           isLoading: false,
//         });
//       }
//     } catch (error) {
//       this.setState({ error: error.message, isLoading: false });
//     }
//   };

//   render() {
//     const { data, isLoading, error } = this.state;

//     if (isLoading) {
//       return <p>Loading graph data...</p>;
//     }

//     if (error) {
//       return <p>Error loading data: {error}</p>;
//     }

//     return (
//       <div>
//         <h2>MEV Price Over Time</h2>
//         <Line data={data} options={{
//           responsive: true,
//           plugins: {
//             legend: {
//               display: true,
//               position: "top",
//             },
//           },
//           scales: {
//             x: {
//               title: {
//                 display: true,
//                 text: "Time",
//               },
//             },
//             y: {
//               title: {
//                 display: true,
//                 text: "Price (USD)",
//               },
//             },
//           },
//         }} />
//       </div>
//     );
//   }
// }

// export default MEVPriceGraph;
